export class Statuses {
    public static ALERT: string = 'alert';
    public static SUCCESS: string = 'success';
    public static INFO: string = 'info';
    public static WARNING: string = 'warning';
    public static DISABLED: string = 'disabled';
}
